/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { verifyPermission } from "../../../helpers/permission";
import { connect } from "react-redux";
import { percentageData } from "../../../helpers/function";
import LoadingTable from "../LoadingTable";
import { verifyTokenExpire } from "../../../middleware/verifyToken";
import { useTranslation } from "react-i18next";

const DashboardClaimsMy = (props) => {
  const { t } = useTranslation();
  const { dateEnd, dateStart, filterdate, spacialdate } = props;
  const [data, setData] = useState(props?.response?.data?.statistics || {});
  const [totalData, setTotalData] = useState(
    props?.response?.data?.statistics?.totalRegistered?.myInstitution
  );
  const [load, setLoad] = useState(true);
  const [componentData, setComponentData] = useState(null);

  useEffect(() => {
    let isCancelled = false;
    async function fetchData() {
      if (!isCancelled) {
        setComponentData(props?.component || null);
        setData(props?.response?.data?.statistics || {});
        setTotalData(props?.response?.data?.totalClaimsRegisteredStatistics || 0);
        setLoad(false);
      }
    }
    if (verifyTokenExpire()) fetchData();
    return () => {
      isCancelled = true;
    };
  }, [props.response, props.component]);

  return verifyPermission(
    props.userPermissions,
    "show-dashboard-data-my-institution"
  ) ? (
    <>
      <div>
        <div className="kt-portlet__head">
          <div className="kt-portlet__head-label">
            <h5 className="kt-portlet__head-title">
              {t("Statistiques des Réclamations de mon institution")}
              {spacialdate !== "" && spacialdate !== undefined
                ? ` ${t("sur les {{count}} derniers {{unit}}", { count: spacialdate?.match(/\d+/)?.[0] || "", unit: spacialdate?.includes("months") ? t("mois") : t("jours") })}`
                : filterdate !== "" && filterdate !== undefined
                ? ` ${t("au")} ${filterdate}`
                : dateStart !== "" && dateStart !== undefined
                ? ` ${t("du {{start}} au {{end}}", { start: dateStart, end: dateEnd })}`
                : ` ${t("sur les 30 derniers jours")}`}
            </h5>
          </div>
        </div>
        {load ? (
          <LoadingTable />
        ) : (
          <div className="kt-portlet__body kt-portlet__body--fit">
            <div className="row row-no-padding row-col-separator-lg">
              {/* Total Enregistrées */}
              <div className="col-md-12 col-lg-4 col-xl-4">
                <div className="kt-widget24">
                  <div className="kt-widget24__details">
                    <div className="kt-widget24__info">
                      <h5 className="kt-widget24__title">
                        {componentData?.params?.fr?.total_enreg?.value || t("Total Réclamations Enregistrées")}
                      </h5>
                      <span className="kt-widget24__desc" />
                    </div>
                    <span className="kt-widget24__stats kt-font-brand">
                      {data?.totalRegistered?.myInstitution ?? "0"}
                    </span>
                  </div>
                </div>
              </div>

              {/* Total Incomplètes */}
              <div className="col-md-12 col-lg-4 col-xl-4">
                <div className="kt-widget24">
                  <div className="kt-widget24__details">
                    <div className="kt-widget24__info">
                      <h5 className="kt-widget24__title">
                        {componentData?.params?.fr?.total_incomplete?.value || t("Total Réclamations Incomplètes")}
                      </h5>
                      <span className="kt-widget24__desc" />
                    </div>
                    <span className="kt-widget24__stats kt-font-danger">
                      {data?.totalIncomplete?.myInstitution ?? "0"}
                    </span>
                  </div>

                  <div className="progress progress--sm">
                    {data?.totalIncomplete ? (
                      <div
                        className="progress-bar kt-bg-danger"
                        role="progressbar"
                        aria-valuenow={percentageData(
                          data?.totalIncomplete?.myInstitution || 0,
                          totalData
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: percentageData(
                            data?.totalIncomplete?.myInstitution || 0,
                            totalData
                          ),
                        }}
                      ></div>
                    ) : null}
                  </div>
                  <div className="kt-widget24__action">
                    <span className="kt-widget24__change">
                      {componentData?.params?.fr?.pourcent_incomplet?.value || t("% Réclamations Incomplètes")}
                    </span>
                    <span className="kt-widget24__number">
                      {percentageData(
                        data?.totalIncomplete?.myInstitution ?? 0,
                        totalData
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Total Complètes */}
              <div className="col-md-12 col-lg-4 col-xl-4">
                <div className="kt-widget24">
                  <div className="kt-widget24__details">
                    <div className="kt-widget24__info">
                      <h5 className="kt-widget24__title">
                        {componentData?.params?.fr?.total_complet?.value || t("Total Réclamations Complètes")}
                      </h5>
                      <span className="kt-widget24__desc" />
                    </div>
                    <span className="kt-widget24__stats ktkt-bg-success">
                      {data?.totalComplete?.myInstitution ?? "0"}
                    </span>
                  </div>

                  <div className="progress progress--sm">
                    {data?.totalComplete ? (
                      <div
                        className="progress-bar kt-bg-success"
                        role="progressbar"
                        aria-valuenow={percentageData(
                          data?.totalComplete?.myInstitution || 0,
                          totalData
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: percentageData(
                            data?.totalComplete?.myInstitution || 0,
                            totalData
                          ),
                        }}
                      ></div>
                    ) : null}
                  </div>
                  <div className="kt-widget24__action">
                    <span className="kt-widget24__change">
                      {componentData?.params?.fr?.pourcent_complete?.value || t("% Réclamations Complètes")}
                    </span>
                    <span className="kt-widget24__number">
                      {percentageData(
                        data?.totalComplete?.myInstitution ?? 0,
                        totalData
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Total Transférées à une Unité */}
              <div className="col-md-12 col-lg-4 col-xl-4">
                <div className="kt-widget24">
                  <div className="kt-widget24__details">
                    <div className="kt-widget24__info">
                      <h5 className="kt-widget24__title">
                        {componentData?.params?.fr?.total_to_unit?.value || t("Total Transférées à une Unité")}
                      </h5>
                      <span className="kt-widget24__desc" />
                    </div>
                    <span className="kt-widget24__stats kt-font-brand">
                      {data?.totalTransferredToUnit?.myInstitution ?? "0"}
                    </span>
                  </div>

                  <div className="progress progress--sm">
                    {data?.totalTransferredToUnit ? (
                      <div
                        className="progress-bar kt-bg-brand"
                        role="progressbar"
                        aria-valuenow={percentageData(
                          data?.totalTransferredToUnit?.myInstitution || 0,
                          totalData
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: percentageData(
                            data?.totalTransferredToUnit?.myInstitution || 0,
                            totalData
                          ),
                        }}
                      ></div>
                    ) : null}
                  </div>
                  <div className="kt-widget24__action">
                    <span className="kt-widget24__change">
                      {componentData?.params?.fr?.pourcent_to_unit?.value || t("% Transférées à une Unité")}
                    </span>
                    <span className="kt-widget24__number">
                      {percentageData(
                        data?.totalTransferredToUnit?.myInstitution ?? 0,
                        totalData
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Total En Cours de Traitement */}
              <div className="col-md-12 col-lg-4 col-xl-4">
                <div className="kt-widget24">
                  <div className="kt-widget24__details">
                    <div className="kt-widget24__info">
                      <h5 className="kt-widget24__title">
                        {componentData?.params?.fr?.total_in_treatment?.value || t("Total En Cours de Traitement")}
                      </h5>
                      <span className="kt-widget24__desc" />
                    </div>
                    <span className="kt-widget24__stats kt-font-warning">
                      {data?.totalBeingProcess?.myInstitution ?? "0"}
                    </span>
                  </div>

                  <div className="progress progress--sm">
                    {data?.totalBeingProcess ? (
                      <div
                        className="progress-bar kt-bg-warning"
                        role="progressbar"
                        aria-valuenow={percentageData(
                          data?.totalBeingProcess?.myInstitution || 0,
                          totalData
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: percentageData(
                            data?.totalBeingProcess?.myInstitution || 0,
                            totalData
                          ),
                        }}
                      ></div>
                    ) : null}
                  </div>
                  <div className="kt-widget24__action">
                    <span className="kt-widget24__change">
                      {componentData?.params?.fr?.pourcent_in_treatment?.value || t("% En Cours de Traitement")}
                    </span>
                    <span className="kt-widget24__number">
                      {percentageData(
                        data?.totalBeingProcess?.myInstitution ?? 0,
                        totalData
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Total Traitées */}
              <div className="col-md-12 col-lg-4 col-xl-4">
                <div className="kt-widget24">
                  <div className="kt-widget24__details">
                    <div className="kt-widget24__info">
                      <h5 className="kt-widget24__title">
                        {componentData?.params?.fr?.total_treat?.value || t("Total Réclamations Traitées")}
                      </h5>
                      <span className="kt-widget24__desc" />
                    </div>
                    <span className="kt-widget24__stats kt-font-success">
                      {data?.totalTreated?.myInstitution ?? "0"}
                    </span>
                  </div>

                  <div className="progress progress--sm">
                    {data?.totalTreated ? (
                      <div
                        className="progress-bar kt-bg-success"
                        role="progressbar"
                        aria-valuenow={percentageData(
                          data?.totalTreated?.myInstitution || 0,
                          totalData
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: percentageData(
                            data?.totalTreated?.myInstitution || 0,
                            totalData
                          ),
                        }}
                      ></div>
                    ) : null}
                  </div>
                  <div className="kt-widget24__action">
                    <span className="kt-widget24__change">
                      {componentData?.params?.fr?.pourcent_treat?.value || t("% Réclamations Traitées")}
                    </span>
                    <span className="kt-widget24__number">
                      {percentageData(
                        data?.totalTreated?.myInstitution ?? 0,
                        totalData
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Total Validées */}
              <div className="col-md-12 col-lg-4 col-xl-4">
                <div className="kt-widget24">
                  <div className="kt-widget24__details">
                    <div className="kt-widget24__info">
                      <h5 className="kt-widget24__title">
                        {componentData?.params?.fr?.total_validated?.value || t("Total Réclamations Validées")}
                      </h5>
                      <span className="kt-widget24__desc" />
                    </div>
                    <span className="kt-widget24__stats kt-font-success">
                      {data?.totalValidated
                        ? (data?.totalValidated?.myInstitution || 0) +
                          (data?.totalTransferredToStaffForSatisfaction?.myInstitution || 0)
                        : "0"}
                    </span>
                  </div>

                  <div className="progress progress--sm">
                    {data?.totalValidated ? (
                      <div
                        className="progress-bar kt-bg-success"
                        role="progressbar"
                        aria-valuenow={percentageData(
                          (data?.totalValidated?.myInstitution || 0) +
                            (data?.totalTransferredToStaffForSatisfaction?.myInstitution || 0),
                          totalData
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: percentageData(
                            (data?.totalValidated?.myInstitution || 0) +
                              (data?.totalTransferredToStaffForSatisfaction?.myInstitution || 0),
                            totalData
                          ),
                        }}
                      ></div>
                    ) : null}
                  </div>
                  <div className="kt-widget24__action">
                    <span className="kt-widget24__change">
                      {componentData?.params?.fr?.pourcent_validated?.value || t("% Réclamations Validées")}
                    </span>
                    <span className="kt-widget24__number">
                      {percentageData(
                        ((data?.totalValidated?.myInstitution || 0) +
                          (data?.totalTransferredToStaffForSatisfaction?.myInstitution || 0)),
                        totalData
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Total Satisfaction Mesurée */}
              <div className="col-md-12 col-lg-4 col-xl-4">
                <div className="kt-widget24">
                  <div className="kt-widget24__details">
                    <div className="kt-widget24__info">
                      <h5 className="kt-widget24__title">
                        {componentData?.params?.fr?.total_satisfated?.value || t("Total Satisfaction Mesurée")}
                      </h5>
                      <span className="kt-widget24__desc" />
                    </div>
                    <span className="kt-widget24__stats kt-font-danger">
                      {data?.totalMeasuredSatisfaction?.myInstitution ?? "0"}
                    </span>
                  </div>

                  <div className="progress progress--sm">
                    {data?.totalMeasuredSatisfaction ? (
                      <div
                        className="progress-bar kt-bg-danger"
                        role="progressbar"
                        aria-valuenow={percentageData(
                          data?.totalMeasuredSatisfaction?.myInstitution || 0,
                          totalData
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: percentageData(
                            data?.totalMeasuredSatisfaction?.myInstitution || 0,
                            totalData
                          ),
                        }}
                      ></div>
                    ) : null}
                  </div>
                  <div className="kt-widget24__action">
                    <span className="kt-widget24__change">
                      {componentData?.params?.fr?.pourcent_satisfated?.value || t("% Satisfaction Mesurée")}
                    </span>
                    <span className="kt-widget24__number">
                      {percentageData(
                        data?.totalMeasuredSatisfaction?.myInstitution ?? 0,
                        totalData
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Total Non Fondées */}
              <div className="col-md-12 col-lg-4 col-xl-4">
                <div className="kt-widget24">
                  <div className="kt-widget24__details">
                    <div className="kt-widget24__info">
                      <h5 className="kt-widget24__title">
                        {componentData?.params?.fr?.total_unfound?.value || t("Total Réclamations Non Fondées")}
                      </h5>
                      <span className="kt-widget24__desc" />
                    </div>
                    <span className="kt-widget24__stats kt-font-success">
                      {data?.totalUnfounded?.myInstitution ?? "0"}
                    </span>
                  </div>

                  <div className="progress progress--sm">
                    {data?.totalUnfounded ? (
                      <div
                        className="progress-bar kt-bg-success"
                        role="progressbar"
                        aria-valuenow={percentageData(
                          data?.totalUnfounded?.myInstitution || 0,
                          totalData
                        )}
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{
                          width: percentageData(
                            data?.totalUnfounded?.myInstitution || 0,
                            totalData
                          ),
                        }}
                      ></div>
                    ) : null}
                  </div>
                  <div className="kt-widget24__action">
                    <span className="kt-widget24__change">
                      {componentData?.params?.fr?.pourcent_unfound?.value || t("% Réclamations Non Fondées")}
                    </span>
                    <span className="kt-widget24__number">
                      {percentageData(
                        data?.totalUnfounded?.myInstitution ?? 0,
                        totalData
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    userPermissions: state?.user?.user?.permissions || [],
  };
};

export default connect(mapStateToProps)(DashboardClaimsMy);